import { Link } from 'react-router-dom'

export function MarketingFooter() {
  return (
    <div style={{
      maxWidth: 1100,
      margin: '80px auto 0',
      padding: '24px 0',
      borderTop: '1px solid rgba(101,79,111,0.18)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 16,
    }}>
      <div style={{
        fontFamily: 'Inter, sans-serif',
        fontSize: 13, color: 'rgba(232,234,246,0.3)',
      }}>
        © 2026 Synergic Systems
      </div>
      <div style={{ display: 'flex', gap: 28 }}>
        {[
          { label: 'Impressum', to: '/impressum' },
          { label: 'AGB', to: '/agb' },
          { label: 'Datenschutz', to: '/datenschutz' },
          { label: 'AVV', to: '/avv' },
        ].map((item) => (
          <Link
            key={item.to}
            to={item.to}
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: 13, fontWeight: 500,
              color: 'rgba(232,234,246,0.35)',
              textDecoration: 'none',
              transition: 'color 150ms ease',
            }}
            onMouseEnter={e => (e.currentTarget.style.color = 'rgba(232,234,246,0.7)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'rgba(232,234,246,0.35)')}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  )
}
